<script>
import feather from 'feather-icons';

export default {
	name: 'Home',
	data: () => {
		return {
			theme: '',
		};
	},
	created() {
		this.theme = localStorage.getItem('theme') || 'light';
	},
	mounted() {
		feather.replace();
		this.theme = localStorage.getItem('theme') || 'light';
	},
	updated() {
		feather.replace();
	},
	methods: {},
};
</script>

<template>
	<section
		class="flex flex-col sm:justify-between items-start sm:flex-row mt-12 sm:mt-24 mb-20"
	>
		<div class="w-full text-left">
			<p
				class="font-mono text-gray-500 dark:text-gray-400 mb-2 text-sm sm:text-base"
			>
				> whoami
			</p>
			<h1
				class="font-sans font-extrabold tracking-tight text-4xl md:text-5xl xl:text-6xl text-primary-dark dark:text-primary-light mb-4"
			>
				Nuruddin Naim
			</h1>
			<p
				class="font-sans font-medium text-xl sm:text-2xl text-gray-600 dark:text-gray-300 max-w-2xl mb-4"
			>
				Freelance Software Developer
			</p>
			<p
				class="font-sans text-lg sm:text-xl text-gray-500 dark:text-gray-400 max-w-2xl leading-relaxed mb-8"
			>
				Building efficient and scalable web applications with modern technologies like React, Vue, and Laravel.
			</p>
			<div class="flex sm:block">
				<a
					download="CV_Nuruddin.pdf"
					href="/files/CV_Nuruddin.pdf"
					class="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-black hover:bg-gray-800 dark:text-black dark:bg-white dark:hover:bg-gray-200 transition-colors duration-300"
					aria-label="Download Resume"
				>
					<i
						data-feather="arrow-down-circle"
						class="mr-2 w-5 h-5"
					></i>
					<span>Download CV</span>
				</a>
			</div>
		</div>
	</section>
</template>

<style scoped></style>
